module.exports = "/assets/data/b900f68fccfb2e91d8158837b021eea8-CW2.data.json";